import { Clock, Wrench, Phone } from "lucide-react";
import { tierInfo, waLink, formatPrice } from "./priceData";

const OnRequest = () => (
    <div className="mt-5 rounded-xl border border-white/10 bg-white/[0.03] p-5 flex flex-col gap-1" data-testid="price-tier-on-request">
        <span className="text-xs uppercase tracking-[0.15em] text-white/50">Preis</span>
        <span className="font-body text-2xl font-bold text-white">auf Anfrage</span>
        <span className="text-xs text-white/50">Kurz per WhatsApp melden – wir nennen Ihnen den Festpreis</span>
    </div>
);

export const PriceResult = ({ model, repair }) => {
    const { name, tiers, duration } = repair;
    const msg = tiers.length
        ? `Hallo RAPID Key & Go, ich interessiere mich für eine Reparatur: ${model} – ${name} (${formatPrice(tiers)}). Wann kann ich vorbeikommen?`
        : `Hallo RAPID Key & Go, was kostet bei Ihnen: ${model} – ${name}?`;

    return (
        <div className="mt-8 animate-[fadeIn_.3s_ease-out]" data-testid="price-result">
            <div className="flex flex-wrap items-baseline justify-between gap-2">
                <p className="font-body text-xl md:text-2xl font-semibold text-white" data-testid="price-result-device">{model}</p>
                <p className="font-body text-sm uppercase tracking-[0.2em] text-brand font-semibold" data-testid="price-result-repair">{name}</p>
            </div>
            {tiers.length === 0 && <OnRequest />}
            <div className={`${tiers.length ? "mt-5" : "hidden"} grid gap-3 ${tiers.length > 2 ? "md:grid-cols-3" : tiers.length > 1 ? "md:grid-cols-2" : ""}`}>
                {tiers.map(([key, price], i) => {
                    const info = tierInfo(key);
                    const tip = tiers.length > 1 && i === 0;
                    return (
                        <div key={key} className={`relative rounded-xl border p-5 flex flex-col gap-1 ${tip ? "border-brand bg-brand/10" : "border-white/10 bg-white/[0.03]"}`} data-testid={`price-tier-${i}`}>
                            {tip && <span className="absolute -top-2.5 left-4 bg-brand text-white text-[10px] tracking-[0.15em] uppercase font-semibold px-2 py-0.5 rounded">Unsere Empfehlung</span>}
                            <span className="text-xs uppercase tracking-[0.15em] text-white/50">{info.label}</span>
                            <span className="font-body text-3xl font-bold text-white" data-testid={`price-tier-value-${i}`}>{price} €</span>
                            <span className="text-xs text-white/50">{info.sub}</span>
                        </div>
                    );
                })}
            </div>
            <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/70">
                <span className="inline-flex items-center gap-2"><Wrench size={15} className="text-brand" /> inkl. Einbau</span>
                {duration && <span className="inline-flex items-center gap-2" data-testid="price-result-duration"><Clock size={15} className="text-brand" /> {duration}</span>}
            </div>
            <a href={waLink(msg)} target="_blank" rel="noopener noreferrer" className="mt-7 flex w-full items-center justify-center bg-brand hover:bg-brandDark text-white py-4 rounded-xl text-sm tracking-[0.15em] uppercase font-semibold transition-colors" data-testid="price-result-cta">
                Jetzt per WhatsApp anfragen
            </a>
            <a href="tel:+499414610027" className="mt-3 flex items-center justify-center gap-2 text-sm text-white/60 underline hover:text-white transition-colors" data-testid="price-result-call">
                <Phone size={14} /> oder kurz anrufen: 0941 4610027
            </a>
            <p className="mt-5 text-xs text-white/40 text-center">* Alle Preise inkl. MwSt. Der Festpreis gilt, sofern bei der Prüfung kein weiterer Schaden festgestellt wird.</p>
        </div>
    );
};
